import { render, staticRenderFns } from "./StaticLoadingIndicatorIcon.vue?vue&type=template&id=54a213cc&scoped=true&"
import script from "./StaticLoadingIndicatorIcon.vue?vue&type=script&lang=js&"
export * from "./StaticLoadingIndicatorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a213cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a213cc')) {
      api.createRecord('54a213cc', component.options)
    } else {
      api.reload('54a213cc', component.options)
    }
    module.hot.accept("./StaticLoadingIndicatorIcon.vue?vue&type=template&id=54a213cc&scoped=true&", function () {
      api.rerender('54a213cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Includes/StaticLoadingIndicatorIcon.vue"
export default component.exports